import React, { CSSProperties, FC, useEffect, memo } from 'react';
import { PAYMENT_INFO_TEST_ID } from 'routes/Checkout/const';

type CloverPaymentInputProps = {
  fieldName: Clover.InputFieldType;
  onValidationBlur: (returnedState: Clover.ReturnedState) => void;
  onValidationChange: (fieldName: Clover.InputFieldType, errors: Clover.ReturnedState) => void;
  className?: string;
  style?:Record<string, CSSProperties>,
  cloverElementsInstance: Clover.ElementRoot;
}

const STYLES: Record<string, CSSProperties> = {
  '.hydrated' : {
    display: 'block',
    height: '2em',
    overflow: 'hidden',
  },
  'input': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    // TODO: Change to colo standard font-size as part of COLO-1115
    fontSize: '16px',
    height: '1.6em',
  },
  'img': {
    height: '1.2em !important',
    width: '1.8em',
  }
};

export const CloverPaymentInputImpl: FC<CloverPaymentInputProps> = ({ style=STYLES,cloverElementsInstance, fieldName, children, onValidationChange, onValidationBlur, ...props }) => {
  const id = fieldName.toLocaleLowerCase();

  const handleOnChange = (returnedState: Clover.ReturnedState) => onValidationChange(fieldName, returnedState);

  const handleOnBlur = (returnedState: Clover.ReturnedState) => onValidationBlur(returnedState);

  useEffect(() => {
    const element = cloverElementsInstance.create(fieldName, style);
    element.mount(`#${id}`);

    element.addEventListener('change', handleOnChange);
    element.addEventListener('blur', handleOnBlur);

    return () => {
      element.removeEventListener('change');
      element.removeEventListener('blur');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id={id} {...props} data-testid={PAYMENT_INFO_TEST_ID.root} />
  );
};

export const CloverPaymentInput = memo(CloverPaymentInputImpl);
